/*
 * Copyright (c) 2022 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
export class BrowserHelper {
  static isOnBrowser = () => {
    return typeof window !== 'undefined' && window.document
  }
}
